import { Injectable, TemplateRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiException } from '../models/models.swagger.generated';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any;
  constructor(
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  private getTranslatedContent(content: string | TemplateRef<any>, placeholder: string = ''): string {
    if (typeof content === 'string') {
      return this.translate.instant(content, { placeholder });
    }
    return '';  
  }

  public show(severity: string, header: string, textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const detail = this.getTranslatedContent(textOrTpl, options.placeholder);
    const message = {
      severity,
      summary: this.translate.instant(header),
      detail,
      life: options.delay || 5000,
      ...options,
    };
    this.messageService.add(message);
  }

  public showSuccess(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '') {
    this.show('success', header, textOrTpl, { delay: 10000 });
  }

  public showWarning(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '') {
    this.show('warn', header, textOrTpl, { delay: 15000 });
  }

  public showError(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '', errorId?: number, errorDetail?: string) {
    let detail = this.getTranslatedContent(textOrTpl, placeholder);
    if (errorDetail) {
      detail += `<div class="error-detail">${this.translate.instant('i18n.errors.details')}: ${errorDetail}</div>`;
    }
    this.show('error', header, detail, { delay: 15000, errorId, escape: false });
  }

  public showApiException(error: ApiException, title: string = 'i18n.errors.server-error.title', messageKey: string = 'i18n.errors.server-error.message') {
    let detail;
    if (ApiException.isApiException(error)) {
      try {
        detail = JSON.parse(error.response).message || error.response;
      } catch {
        detail = error.response;
      }
      this.showError(title, messageKey, null, null, detail);
    } else {
      this.showError(title, messageKey);
    }
  }
    public doesErrorExistAlready(errorId: number) {
    if (!errorId) {
      return false;
    }
    return this.toasts.find(t => t.errorId === errorId) != null;
  }
}